import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { LocalStorageService } from 'src/modules/shared/services/local-storage.service';
import { BackgroundCheckStatus } from 'src/modules/authentication/interfaces/user.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-background-check',
  templateUrl: './background-check.component.html',
  styleUrls: ['./background-check.component.scss'],
  standalone: false
})
export class BackgroundCheckComponent implements OnInit {
  userEmail: string | null = null;
  backgroundCheckStatus: BackgroundCheckStatus =
    BackgroundCheckStatus.NOT_REQUIRED;

  constructor(
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}

  async ngOnInit() {
    const user = await this.localStorageService.getLoggedInUserInfo();
    if (user) {
      this.backgroundCheckStatus = user.backgroundCheckStatus;
      this.userEmail = user.email || null;
    }
  }

  goBack() {
    // Navigate to previous page if possible; otherwise fall back to home
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.navigateByUrl('/home');
    }
  }
}
